import InputButton from 'Components/UI/Organisms/Plant/Stock/PaperDevolution/DialogDevolution/InputButton'
import { CITIES, CONDICION, PROVINCIAS } from 'Constants'

export const ClientsFACT = (
  data,
  handleChangeCteFact,
  edit,
  dataBefore,
  info,
  setInfo,
  isLoading,
  setIsLoading,
  handleSubmitCode,
  permissions,
  comprobantesNDNC
) => {
  const condIvaLabel = CONDICION.find((item) => item.id === data.clienteFactura.cond_iva)?.label
  const provinciaId = PROVINCIAS.find(
    (p) =>
      p.provincia.trim() ===
      (data.clienteFactura?.provincia?.trim() || data.ctaCliente.provincia.trim())
  )?.id
  const cp = CITIES.find(
    (city) => city.localidad === (data.clienteFactura.localidad || data.ctaCliente.localidad.trim())
  )?.cp
  const localidadesFiltradas = CITIES.filter((city) => city.provincia_id === provinciaId)
  const tipoResponsable = dataBefore?.data.tipo_responsable?.find(
    (item) => item.name === info.tipo_responsable
  )?.name
  const responsable = dataBefore.data.tipo_responsable.find((v) => v.value === 5).name

  return [
    !comprobantesNDNC.includes(data.infoMain.comprobante) && {
      class: 'custom',
      name: 'search',
      component: (
        <InputButton
          placeholder="CUIT/CUIL/DNI O NOMBRE"
          name="search"
          onSubmit={() => handleSubmitCode(info)}
          onKeyUp={(e) => {
            const { value } = e.target
            setInfo((prevInfo) => ({
              ...prevInfo,
              search: value,
            }))
          }}
          //disabled={permissions.allowEditMin ? true : !edit}
          value={info.search}
          resetFormDisabled
          loading={isLoading}
          noHeight
        />
      ),
      //disabled: permissions.allowEditMin ? true : !edit,
      sm: 6,
      xs: 12,
    },
    {
      class: 'textfield',
      name: 'nombre',
      label: 'Razón social',
      value: info.nombre,
      disabled: true,
      sm: comprobantesNDNC.includes(data.infoMain.comprobante) ? 12 : 6,
      xs: 12,
    },
    {
      class: 'textfield',
      name: 'cond_iva',
      label: 'Condición',
      value: condIvaLabel,
      sm: 4,
      xs: 12,
      disabled: true,
    },
    {
      class: 'textfield',
      name: 'cuit',
      label: 'CUIT/CUIL/DNI',
      value: info.cuit,
      sm: 4,
      xs: 12,
      disabled: true,
    },
    {
      class: 'autocomplete',
      sm: 4,
      xs: 12,
      name: 'tipo_responsable',
      label: 'Tipo responsable',
      optionValue: 'name',
      options: dataBefore.data.tipo_responsable,
      optionLabel: `options["name"]`,
      //defaultValue: dataBefore.data.tipo_responsable.find((v) => v.value === 5) ,
      value:
        typeof data.clienteFactura.tipo_responsable === 'string'
          ? data.clienteFactura.tipo_responsable
          : tipoResponsable
            ? tipoResponsable
            : responsable,
      disabled: comprobantesNDNC.includes(data.infoMain.comprobante)
        ? true
        : permissions.allowEditMin
          ? true
          : !edit,
      onChange: (e) => {
        handleChangeCteFact('tipo_responsable', e.name)
      },
    },
    {
      class: 'autocomplete',
      sm: 3,
      xs: 12,
      name: 'provincia',
      label: 'Provincia',
      optionValue: 'provincia',
      options: PROVINCIAS,
      optionLabel: `options["provincia"]`,
      value: data.clienteFactura.provincia
        ? data.clienteFactura.provincia.trim()
        : data.ctaCliente.provincia.trim(),
      disabled: comprobantesNDNC.includes(data.infoMain.comprobante)
        ? true
        : permissions.allowEditMin
          ? true
          : !edit,
      onChange: (e) => handleChangeCteFact('provincia', e.provincia),
    },
    {
      class: 'autocomplete',
      sm: 3,
      xs: 12,
      name: 'localidad',
      label: 'Localidad',
      optionValue: 'localidad',
      options: localidadesFiltradas,
      optionLabel: `options["localidad"]`,
      value: data.clienteFactura.localidad
        ? data.clienteFactura.localidad.trim()
        : data.ctaCliente.localidad.trim(),
      disabled: comprobantesNDNC.includes(data.infoMain.comprobante)
        ? true
        : permissions.allowEditMin
          ? true
          : !edit,
      onChange: (e) => handleChangeCteFact('localidad', e.localidad),
    },
    {
      class: 'textfield',
      type: 'number',
      name: 'cp',
      label: 'Código postal',
      value: cp,
      sm: 2,
      xs: 12,
      disabled: comprobantesNDNC.includes(data.infoMain.comprobante)
        ? true
        : permissions.allowEditMin
          ? true
          : !edit,
      onChange: (e) => {
        handleChangeCteFact('cp', e.target.value)
      },
    },
    {
      class: 'textfield',
      sm: 4,
      xs: 12,
      name: 'domicilio',
      label: 'Dirección',
      value: data.clienteFactura.domicilio
        ? data.clienteFactura.domicilio
        : data.ctaCliente.domicilio.trim(),
      disabled: comprobantesNDNC.includes(data.infoMain.comprobante)
        ? true
        : permissions.allowEditMin
          ? true
          : !edit,
      onChange: (e) => {
        handleChangeCteFact('domicilio', e.target.value)
      },
    },
    {
      class: 'textfield',
      type: 'number',
      name: 'telefono',
      label: 'Teléfono',
      value: data.clienteFactura.telefono ? data.clienteFactura.telefono : data.ctaCliente.telefono,
      sm: 6,
      xs: 12,
      disabled: comprobantesNDNC.includes(data.infoMain.comprobante)
        ? true
        : permissions.allowEditMin
          ? true
          : !edit,
      onChange: (e) => {
        handleChangeCteFact('telefono', e.target.value)
      },
    },
    {
      class: 'textfield',
      name: 'email',
      label: 'Email',
      value: data.clienteFactura.email ? data.clienteFactura.email : data.ctaCliente.email,
      disabled: comprobantesNDNC.includes(data.infoMain.comprobante)
        ? true
        : permissions.allowEditMin
          ? true
          : !edit,
      sm: 6,
      xs: 12,
      onChange: (e) => {
        handleChangeCteFact('email', e.target.value)
      },
    },
  ]
}
